import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { map } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { sortFn } from "../Utils.js";
import { int32ToString, createObj, equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Tickets_Severity_FromId_Z524259A4, Tickets_TicketStatus, Tickets_TicketStatus_FromId_Z524259A4 } from "../Shared/Shared.js";
import { map as map_1, getSubArray } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { onPageChange, headerSortCell } from "../ViewHelpers.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TablePagination, TableContainer, Link, TableBody, TableRow, TableHead, Table, Checkbox, FormControlLabel, Typography, TableCell } from "@mui/material";
import { singleton, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import Info from "@mui/icons-material/Info";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Tickets_SeverityChip_5E2CD6A8 } from "./Tickets/SeverityChip.js";
import { Tickets_StatusChip_Z17F2D702 } from "./Tickets/StatusChip.js";

export function Components_OpenTicketsTable_334C27A3(components_OpenTicketsTable_334C27A3InputProps) {
    let elems, elems_1, props_10, children_1, elements_4, elements_1, elements, elements_3, values;
    const tickets = components_OpenTicketsTable_334C27A3InputProps.tickets;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(true);
    const asc = patternInput[0];
    const patternInput_1 = reactApi.useState("Id");
    const sortKey = patternInput_1[0];
    const patternInput_2 = reactApi.useState(0);
    const setPage = patternInput_2[1];
    const page = patternInput_2[0] | 0;
    const patternInput_3 = reactApi.useState(5);
    const rowsPerPage = patternInput_3[0] | 0;
    const patternInput_4 = reactApi.useState(false);
    const onlyMine = patternInput_4[0];
    const patternInput_5 = reactApi.useState(false);
    const closed = patternInput_5[0];
    const accountIdOpt = map((sess) => sess.UserId, ctx.Session);
    const rowsToSkip = (page * rowsPerPage) | 0;
    let rowsToTake;
    const nextTakeCount = (rowsToSkip + rowsPerPage) | 0;
    rowsToTake = ((tickets.length < nextTakeCount) ? (tickets.length - rowsToSkip) : rowsPerPage);
    const sorted = sortFn(asc, sortKey)(tickets.filter((ticket) => {
        if (closed ? true : !equals(Tickets_TicketStatus_FromId_Z524259A4(ticket.Status), new Tickets_TicketStatus(4, []))) {
            if (!onlyMine) {
                return true;
            }
            else {
                return equals(ticket.Creator.AccountId, accountIdOpt);
            }
        }
        else {
            return false;
        }
    }));
    const currentRows = getSubArray(sorted, rowsToSkip, rowsToTake);
    const th = (key_1, label) => headerSortCell(sortKey, asc, (key) => {
        patternInput_1[1](key);
        patternInput[1]((key !== sortKey) ? true : !asc);
    }, key_1, label);
    const cell = (child) => MuiHelpers_createElement(TableCell, [["children", createElement("div", {
        style: {
            display: "flex",
        },
        children: child,
    })]]);
    const xs_6 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
    }], (elems = [createElement("div", {
        style: {
            flexGrow: 1,
        },
        children: MuiHelpers_createElement(Typography, [["variant", "h4"], ["children", ctx.Locale.t("Dashboard.OpenTickets")]]),
    }), MuiHelpers_createElement(FormControlLabel, [["label", ctx.Locale.t("TicketList.MyTicketsShort")], ["checked", onlyMine], ["onChange", (e) => {
        const newOnlyMine = e.target.checked;
        setPage(0);
        patternInput_4[1](newOnlyMine);
    }], ["control", MuiHelpers_createElement(Checkbox, [])]]), MuiHelpers_createElement(FormControlLabel, [["label", ctx.Locale.t("Ticket.Status.Closed")], ["checked", closed], ["onChange", (e_1) => {
        patternInput_5[1](e_1.target.checked);
    }], ["control", MuiHelpers_createElement(Checkbox, [])]])], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 10 + "px",
    }], (elems_1 = [(props_10 = {}, react.createElement(Info, props_10)), MuiHelpers_createElement(Typography, [["children", ctx.Locale.t("Dashboard.TicketTab")]])], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (children_1 = singleton(MuiHelpers_createElement(Table, [(elements_4 = [MuiHelpers_createElement(TableHead, [(elements_1 = [MuiHelpers_createElement(TableRow, [(elements = [th("Customer", ctx.Locale.t("Customer.Customer")), th("Severity", ctx.Locale.t("Ticket.Severity.Severity")), th("Id", "#"), th("Status", ctx.Locale.t("Ticket.Status.Status"))], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]), MuiHelpers_createElement(TableBody, [(elements_3 = map_1((ticket_1) => {
        let elements_2;
        const ticketUrl = RouterModule_encodeParts(ofArray(["tickets", int32ToString(ticket_1.Id)]), 1);
        let severityChip;
        const severity = Tickets_Severity_FromId_Z524259A4(ticket_1.Severity);
        severityChip = createElement(Tickets_SeverityChip_5E2CD6A8, {
            severity: severity,
        });
        let statusChip;
        const status_1 = Tickets_TicketStatus_FromId_Z524259A4(ticket_1.Status);
        statusChip = createElement(Tickets_StatusChip_Z17F2D702, {
            status: status_1,
            readOnly: true,
        });
        return MuiHelpers_createElement(TableRow, [(elements_2 = [cell(MuiHelpers_createElement(Typography, [["variant", "body2"], ["sx", {
            maxWidth: 30 + "ch",
        }], ["noWrap", true], ["children", ticket_1.Customer.Name]])), cell(severityChip), cell(MuiHelpers_createElement(Link, [["href", ticketUrl], ["children", `#${ticket_1.Id}`]])), cell(statusChip)], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
    }, currentRows), ["children", reactApi.Children.toArray(Array.from(elements_3))])])], ["children", reactApi.Children.toArray(Array.from(elements_4))])])), MuiHelpers_createElement(TableContainer, [["children", reactApi.Children.toArray(Array.from(children_1))]])), MuiHelpers_createElement(TablePagination, [["component", "div"], ["count", sorted.length], ["page", page], ["rowsPerPage", rowsPerPage], (values = (new Int32Array([5, 10, 20])), ["rowsPerPageOptions", Array.from(values)]), ["onPageChange", ((arg10$0040, newPage) => {
        onPageChange(setPage, arg10$0040, newPage);
    })], ["onRowsPerPageChange", (ev) => {
        const newRowsPerPage = ev.target.value | 0;
        setPage(0);
        patternInput_3[1](newRowsPerPage);
    }]])];
    return react.createElement(react.Fragment, {}, ...xs_6);
}

